<template>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
    <v-snackbar v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{message}}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-card class="neu-glow">
        <v-card-title primary-title>
        <div class="text-h5">{{$t(page+'.Fattura Elettronica')}} <span class="subtitle-1">({{$t(page+'.with red background')}})</span></div>
    </v-card-title>
    <v-container grid-list-xl fluid>
    <v-row>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.REA Office')"
              name="REAUfficio"
              v-model="form.REAUfficio"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.REAUfficio.$touch()"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              clearable             
              @input.native="save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.REA Number')"
              name="REANumero"
              v-model="form.REANumero"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.REANumero.$touch()"
              filled
              outlined
              dense
              clearable             
              @input.native="save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-dialog
            ref="READata_dialog"
            v-model="READata_modal"
            :return-value.sync="READata"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="READata"
                :label="$t(page+'.REA Date')"
                prepend-icon="fas fa-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="READata"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="READata_modal = false"
              >
                {{$t(page+'.Cancel')}}
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.READata_dialog.save(READata)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Company Type')"
            v-model="form.CompanyType"
            name="CompanyType"
            @change="save2($event, 'CompanyType')"
            :items="CompanyTypeItems"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.CompanyType.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Tax System')"
            v-model="form.RegimeFiscale"
            name="RegimeFiscale"
            @change="save2($event, 'RegimeFiscale')"
            :items="RegimeFiscaleItems"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.RegimeFiscale.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Socio Unico')"
            v-model="form.SocioUnico"
            name="SocioUnico"
            @change="save2($event, 'SocioUnico')"
            :items="SocioUnicoItems"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.SocioUnico.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Stato Liquidazione')"
            v-model="form.StatoLiquidazione"
            name="StatoLiquidazione"
            @change="save2($event, 'StatoLiquidazione')"
            :items="StatoLiquidazioneItems"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.StatoLiquidazione.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Esigibilita IVA')"
            v-model="form.EsigibilitaIVA"
            name="EsigibilitaIVA"
            @change="save2($event, 'EsigibilitaIVA')"
            :items="EsigibilitaIVAItems"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.EsigibilitaIVA.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.EORI')"
            v-model="form.EORI"
            name="EORI"
            @change="save2($event, 'EORI')"
            :items="EORIItems"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.EORI.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Albo Professionale')"
            v-model="form.AlboProfessionale"
            name="AlboProfessionale"
            @change="save2($event, 'AlboProfessionale')"
            :items="AlboProfessionaleItems"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.AlboProfessionale.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Provincia Albo')"
            v-model="form.ProvinciaAlbo"
            name="ProvinciaAlbo"
            @change="save2($event, 'ProvinciaAlbo')"
            :items="ProvinciaAlboItems"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.ProvinciaAlbo.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Numero Iscrizione Albo')"
              name="NumeroIscrizioneAlbo"
              v-model="form.NumeroIscrizioneAlbo"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.NumeroIscrizioneAlbo.$touch()"
              filled
              outlined
              dense
              clearable             
              @input.native="save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-dialog
            ref="DataIscrizioneAlbo_dialog"
            v-model="DataIscrizioneAlbo_modal"
            :return-value.sync="DataIscrizioneAlbo"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="DataIscrizioneAlbo"
                :label="$t(page+'.Data Iscrizione Albo')"
                prepend-icon="fas fa-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="DataIscrizioneAlbo"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="DataIscrizioneAlbo_modal = false"
              >
                {{$t(page+'.Cancel')}}
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.DataIscrizioneAlbo_dialog.save(DataIscrizioneAlbo)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Art73')"
            v-model="form.Art73"
            name="Art73"
            @change="save2($event, 'Art73')"
            :items="Art73Items"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.Art73.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Art73')"
            v-model="form.Art73"
            name="Art73"
            @change="save2($event, 'Art73')"
            :items="Art73Items"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.Art73.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.Tipo Cassa')"
            v-model="form.TipoCassa"
            name="TipoCassa"
            @change="save2($event, 'TipoCassa')"
            :items="TipoCassaItems"
            :error-messages="fieldErrors('form.locale')"
            @blur="$v.form.TipoCassa.$touch()"
            required
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Aliquota Cassa')"
              name="AliquotaCassa"
              v-model="form.AliquotaCassa"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.AliquotaCassa.$touch()"
              filled
              outlined
              dense
              clearable
              reverse
              type="number"
              @input.native="save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Aliquota Ritenuta')"
              name="AliquotaRitenuta"
              v-model="form.AliquotaRitenuta"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.AliquotaRitenuta.$touch()"
              filled
              outlined
              dense
              clearable
              reverse
              type="number"         
              @input.native="save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Capitale Sociale')"
              name="CapitaleSociale"
              v-model="form.CapitaleSociale"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.CapitaleSociale.$touch()"
              reverse
              type="number"
              filled
              outlined
              dense
              clearable             
              @input.native="save"
          ></v-text-field>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Codice Fiscale Dichiarante SDI')"
              name="SDI_FiscalID"
              v-model="form.SDI_FiscalID"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.SDI_FiscalID.$touch()"
              filled
              outlined
              dense
              clearable
              @input.native="save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.PEC SDI')"
              name="SDI_PEC"
              v-model="form.SDI_PEC"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.SDI_PEC.$touch()"
              filled
              outlined
              dense
              clearable             
              @input.native="save"
          ></v-text-field>
        </v-col>
        </v-col>
      </v-row>
    </v-container>
</v-card>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { availableCountries  } from "@/config/countries";
import _ from 'lodash'
const defaultForm = {
  company: "",
  address: "",
  postalcode: "",
  buildingnumber:"",
  city: "",
  stateorprovince: "",
  country: "",
  companyid: "",
  vatnumber: "",
  sdi: "",
  pec:"",
  iban:"",
  swift:""
};

export default {
  mixins: [validationMixin],
  validations: {
    form: {
      company: { required },
      address: { required },
      buildingnumber: { required},
      postalcode: { required, maxLength: maxLength(8) },
      city: { required },
      stateorprovince: { required },
      country: { required },
      companyid: { required },
      vatnumber: { required },
      sdi: { required },
      pec: { required },
      iban: { required }
    },
  },
  validationMessages: {
    form: {
      company: { required: "Choose your favorite animal" },
      address: { required: "Choose your favorite animal" },
      buildingnumber: { required: "enter building name" },
      city: { required: "City is required" },
      stateorprovince: { required: "State is required" },
      country: { required: "Country is required" },
      companyid: { required: "CompanyID is required" },
      vatnumber: { required: "TAX Number is required" },
      sdi: { required: "SDI is required" },
      iban: { required: "IBAN is required" },
      postalcode: {
        required: "PostalCode is required",
        maxLength: "Max 8 characters",
      },
    },
  },
  data() {
    return {
      page: "Account",
      form: this.$store.state.userdata.user,
      countries: availableCountries,
      snackbar: false,     
      message:'',
      snackbar_color:'success', 
      CompanyTypeItems:[],
      RegimeFiscaleItems:[],
      SocioUnicoItems:[],
      StatoLiquidazioneItems:[],
      EsigibilitaIVAItems:[],
      EORIItems:[],
      AlboProfessionaleItems:[],
      ProvinciaAlboItems:[],
      Art73Items:[],
      TipoCassaItems:[],
      
    };
  },
  computed: {
      ...mapGetters(["user"]),
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.resetForm();
      this.$v.$reset();
    },
    save: _.debounce(function (event) {
        this.updateDB(event.target.name,event.target.value)
    }, 1000),
    save2(value, field) {
      //console.log(value, field);
      this.updateDB(field, value)
    },
    async updateDB(fieldname,fieldvalue){
      try{
          const res = await this.$http.post('/account/account_write.php', {"fieldname":fieldname,"fieldvalue":fieldvalue});
          console.log(res);
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success'
          }
          else
          {
            this.snackbar_color='error'
          }
          this.message=res.data.message;
          this.snackbar=true;
          //this.$store.dispatch("setUser", res.data.user); 
      } catch(e)
      {
        console.log(e)
      }
    }, 
  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  },
};
</script>